import React from 'react'

import { Header } from 'components/Header'
import { BrowserRouter } from 'react-router-dom'

import './tailwind.css'
import { useListenTranslate } from './hooks/translate'

const Root: React.FC = () => {
  useListenTranslate()
  return (
    <BrowserRouter>
      <Header />
    </BrowserRouter>
  )
}

export default Root
